
export const FETCH_DERNIER_DOCS_REQUEST = 'FETCH_DERNIER_DOCS_REQUEST';
export const FETCH_DERNIER_DOCS_SUCCESS = 'FETCH_DERNIER_DOCS_SUCCESS';
export const FETCH_DERNIER_DOCS_FAILURE = 'FETCH_DERNIER_DOCS_FAILURE';
export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';